
<Popup
  v-model:visible="currentVisible"
  :visible.sync="currentVisible"
  :class="classes(n('wrapper'))"
  position="bottom"
  :close-on-click-overlay="false"
  :lock-scroll="lockScroll"
  :overlay-class="overlayClass"
  :destroy-on-close="destroyOnClose"
  :teleport="teleport"
  :duration="0.3"
  :overlay="true"
  @open="handleOpen"
  @opened="handleOpened"
  @closed="handleClosed"
  @clickOverlay="handleOverlayClick"
  @close="handleCloseEvent"
>
  <div
    v-if="shouldRender"
    :class="classes(n())"
    :style="dialogStyle"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="titleId"
    :aria-describedby="contentId"
  >
    <!-- 标题区域 -->
    <div
      :id="titleId"
      :class="classes(
        n('header'),
        {
          [n('header--with-subtitle')]: subTitle && !$slots.header && !$slots['header-center'],
          [n('header--with-title')]: hasTitle,
          [n('header--empty')]: isEmptyHeader
        }
      )"
    >
      <!-- 方式1：使用整体 header slot（优先级最高） -->
      <slot
        v-if="$slots.header"
        name="header"
      />

      <!-- 方式2：使用分区域 slot -->
      <template v-else>
        <!-- 左上角区域 -->
        <div
          v-if="hasHeaderLeft || hasHeaderRight"
          :class="classes(
            n('header-left'),
            {
              [n('header-left--paired')]: hasHeaderRight && !hasHeaderLeft
            }
          )"
        >
          <slot name="header-left">
            <!-- 默认：关闭按钮（如果 showClose=true） -->
            <div
              v-if="showClose"
              :class="n('close')"
              role="button"
              tabindex="0"
              :aria-label="closeAriaLabel"
              @click="handleCloseClick"
            >
              <CloseIcon
                width="48"
                height="48"
                color="#000000E6"
              />
            </div>
          </slot>
        </div>

        <!-- 中间区域 -->
        <div :class="n('header-center')">
          <slot name="header-center">
            <!-- 默认：标题和副标题（垂直布局） -->
            <div
              v-if="title || subTitle"
              :class="n('header-title')"
            >
              <span
                v-if="title"
                :class="n('header-title-main')"
              >
                {{ title }}
              </span>
              <span
                v-if="subTitle"
                :class="n('header-title-sub')"
              >
                {{ subTitle }}
              </span>
            </div>
          </slot>
        </div>

        <!-- 右上角区域 -->
        <div
          v-if="hasHeaderLeft || hasHeaderRight"
          :class="classes(
            n('header-right'),
            {
              [n('header-right--paired')]: hasHeaderLeft
            }
          )"
        >
          <slot name="header-right" />
        </div>
      </template>
    </div>

    <!-- 内容区：根据 scrollable 控制是否可滚动 -->
    <!-- Liteapp 环境使用 scroll-view -->
    <scroll-view
      v-if="isLiteapp"
      :id="contentId"
      ref="bodyRef"
      :class="classes(
        n('body'),
        {
          [n('body--with-gradient')]: shouldShowGradient,
          [n('body--no-scroll')]: !scrollable
        }
      )"
      :scroll-y="scrollable"
      :scroll-config="scrollable ? 'default' : 'disable'"
      :show-scrollbar="false"
      @scroll="handleScrollViewScroll"
    >
      <slot />
    </scroll-view>

    <!-- H5 环境使用原生 div -->
    <div
      v-else
      :id="contentId"
      ref="bodyRef"
      :class="classes(
        n('body'),
        {
          [n('body--with-gradient')]: shouldShowGradient,
          [n('body--no-scroll')]: !scrollable
        }
      )"
      @scroll="handleScroll"
    >
      <slot />
    </div>

    <!-- 底部操作区：固定不滚动 -->
    <div
      v-if="$slots.footer || actions.length > 0"
      :class="classes(
        n('footer'),
        { [n('footer--with-gradient')]: shouldShowGradient }
      )"
    >
      <!-- 方式1：使用 actions 配置（组件自动渲染） -->
      <template v-if="!$slots.footer && actions.length > 0">
        <div
          :class="classes(
            n('actions'),
            {
              [n('actions--horizontal')]: actionsLayout === 'horizontal' && actions.length === 2,
              [n('actions--vertical')]: actionsLayout === 'vertical' && actions.length === 2,
              [n('actions--single')]: actions.length === 1
            }
          )"
        >
          <Button
            v-for="(action, index) in actions"
            :key="action.key"
            :type="action.type || 'primary'"
            :theme="action.theme || 'default'"
            :disabled="action.disabled"
            size="large"
            :aria-label="action.text"
            @click="handleActionClick(action, index)"
          >
            {{ action.text }}
          </Button>
        </div>
      </template>

      <!-- 方式2：使用 footer slot（完全自定义，优先级最高） -->
      <slot name="footer" />
    </div>
  </div>
</Popup>
